import { render, staticRenderFns } from "./instagram.vue?vue&type=template&id=d32b48ea&scoped=true&"
var script = {}
import style0 from "./instagram.vue?vue&type=style&index=0&id=d32b48ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32b48ea",
  null
  
)

export default component.exports